import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { LinearProgress } from '@app-velocity/ui';

import { useUsageContext } from '../../../../context/useUsageContext';

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(3),
  borderRadius: theme.spacing(3),
  '.MuiLinearProgress-bar': {
    borderRadius: theme.spacing(3),
  },
}));

const ProgressContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const ProgressHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 12,
  lineHeight: 1.5,
  flex: 1,
  width: '100%',
  gap: theme.spacing(2),
  color: 'var(--text-text-secondary-color)',
}));

export const UsageProgress = () => {
  const { t } = useI18n();
  const { simStatsByUser } = useUsageContext();

  const value = simStatsByUser?.currentlyUsedSims || 0;
  const max = simStatsByUser?.currentSimsLimit || 0;

  const progress = Math.min((value / max) * 100, 100).toFixed(2);

  const normalizedValue = value > max ? max : value;

  return (
    <ProgressContainer>
      <ProgressHeader>
        {t('teams:usage.simulations.progress')}
        <span>{progress}%</span>
      </ProgressHeader>
      <StyledLinearProgress
        value={normalizedValue}
        max={max}
        variant="determinate"
      />
    </ProgressContainer>
  );
};
